import React from 'react';
import './navbar.css';
import logo from "../../assets/logo/luxorystudioslogo.jpeg";

function Navbar() {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-black fixed-top px-lg-4 py-3 border-bottom border-secondary border-opacity-25">
            <div className="container-fluid">
                {/* Brand / Logo */}
                <a href='/'>
                    <img src={logo} width={100} height={100} />

                </a>

                {/* Mobile Hamburger Toggle */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNavDropdown"
                    aria-controls="navbarNavDropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Nav Links & Search */}
                <div className="collapse navbar-collapse justify-content-between" id="navbarNavDropdown">
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-2 align-items-center">
                        {/* Home */}
                        <li className="nav-item">
                            <a className="nav-link active text-danger fw-semibold" href="#home">
                                Home
                            </a>
                        </li>

                        {/* About Us */}
                        <li className="nav-item">
                            <a className="nav-link text-light" href="#about">
                                About Us
                            </a>
                        </li>

                        {/* Casting Calls Dropdown
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle text-light"
                href="#casting-calls"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Casting Calls
              </a>
              <ul className="dropdown-menu dropdown-menu-dark">
                <li><a className="dropdown-item" href="#tv-show">TV Show</a></li>
                <li><a className="dropdown-item" href="#actors">Actors</a></li>
              </ul>
            </li> */}

                        {/* Models Dropdown */}
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle text-light"
                                href="#models"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Models
                            </a>
                            <ul className="dropdown-menu dropdown-menu-dark">
                                <li><a className="dropdown-item" href="/female-models">Female</a></li>
                                <li><a className="dropdown-item" href="/male-models">Male</a></li>
                                <li><a className="dropdown-item" href="/childfemale-models">Child Female</a></li>
                                <li><a className="dropdown-item" href="/childmale-models">Child Male</a></li>
                            </ul>
                        </li>

                        {/* Photoshoot Dropdown */}
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle text-light"
                                href="#photoshoot"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Photoshoot
                            </a>
                            <ul className="dropdown-menu dropdown-menu-dark">
                                <li><a className="dropdown-item" href="#fashion">Fashion Photos</a></li>
                                <li><a className="dropdown-item" href="#modeling">Modeling Photos</a></li>
                                <li><a className="dropdown-item" href="#modeling">Portfolio</a></li>
                            </ul>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link text-light" href="/contactus">
                                Contact Us
                            </a>
                        </li>
                    </ul>

                    {/* Right Search Input */}
                    <div className="search-box position-relative mt-3 mt-lg-0">
                        <input
                            type="text"
                            className="form-control rounded-pill bg-black text-light border-secondary ps-4 pe-5"
                            placeholder="Search for Artists..."
                        />
                        <i className="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3 text-secondary"></i>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;